export function privateTaskSupportingText({
  hasDistinctAssignee,
  hasSelectedTeams = false
}: {
  hasDistinctAssignee: boolean;
  hasSelectedTeams?: boolean;
}): string {
  if (hasSelectedTeams) {
    return hasDistinctAssignee
      ? "Only you, the assignee, and selected Teams can view this task"
      : "Only you and selected Teams can view this task";
  }

  return hasDistinctAssignee ? "Only you and the assignee can view this task" : "Only you can view this task";
}

export function teamVisibilitySupportingText(): string {
  return "Listed on Department Tasks; members can also view private tasks";
}

export function hasDistinctPrivateAssignee(
  assigneeId: string | null | undefined,
  currentUserId: string | null | undefined
): boolean {
  return Boolean(assigneeId && currentUserId && assigneeId !== currentUserId);
}
